import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import toast from 'react-hot-toast';
import { forgotPassword } from '../../../api/auth';
import { PageMeta } from '../shared/PageMeta';

const schema = z.object({ email: z.string().email() });

export function ForgotPasswordPage() {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm<{ email: string }>({
    resolver: zodResolver(schema),
  });

  const onSubmit = async (data: { email: string }) => {
    setLoading(true);
    try {
      await forgotPassword(data.email);
      setSent(true);
    } catch {
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-16">
      <PageMeta title="Forgot Password" description="Reset your password" path="/marketplace/forgot-password" />
      <div className="max-w-md mx-auto card p-8">
        {sent ? (
          <div className="text-center">
            <h2 className="text-2xl mb-2">Check Your Email</h2>
            <p className="text-spi-slate text-sm mb-6">If an account with that email exists, we've sent a password reset link.</p>
            <Link to="/marketplace/login" className="btn btn-primary">Back to Login</Link>
          </div>
        ) : (
          <>
            <h2 className="text-2xl mb-2 text-center">Forgot Password</h2>
            <p className="text-spi-slate text-sm text-center mb-6">Enter your email to receive a reset link</p>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              <div>
                <label className="input-label">Email</label>
                <input {...register('email')} type="email" className="input" />
                {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
              </div>
              <button type="submit" disabled={loading} className="btn btn-primary w-full">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <p className="text-center text-sm text-spi-slate mt-4">
              <Link to="/marketplace/login" className="text-spi-green hover:underline">Back to Login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
